// extracted by mini-css-extract-plugin
export default {"userMenu":"_3DhkY-o1_OBAk8fn7CCAO3"};